// import React from "react";
// import { Typography } from "@mui/material";
// import { CircularProgress, Box, useMediaQuery, Button } from "@mui/material";

// import MigaPan from "../Componentes/MigaPan";

// const DashBoard = () => {

//   return (
//     <Box className="box-contenido-alineado-izquierda">
//       <MigaPan
//         breadcrumbs={[
//           { label: "DashBoard", href: "/" },
//         ]}
//       />

//       <Typography>Aqui mostraremos datos estadísticos, operaciones en curso, etc</Typography>
//     </Box>
//   )
// };

// export default DashBoard;
import React from "react";
import { Grid, Card, CardContent, Typography, Box } from "@mui/material";

const Dashboard = () => {
  const stats = [
    { label: "Clientes", value: 4 },
    { label: "Buques", value: 651 },
    { label: "Consignatarios", value: 23 },
  ];

  return (
    <Box className="box-contenido-alineado-izquierda">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} md={4}>
          {/* <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="h5" fontWeight="bold">
                Tarifa Vigente
              </Typography>
              <Typography variant="h6" gutterBottom>
                Tarifa 2.025
              </Typography>
            </CardContent>
          </Card> */}
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          {/* <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="h5" fontWeight="bold">
                Buques
              </Typography>
              <Typography variant="h6" gutterBottom>
                618 Buques Informados
              </Typography>
            </CardContent>
          </Card> */}
        </Grid>
        <Grid item xs={12} sm={6} md={4}></Grid>

        <Grid item xs={12} sm={6} md={4}>
          {/* <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="h5" fontWeight="bold">
                Operaciones Pendientes
              </Typography>
              <Typography variant="h6" gutterBottom>
                5
              </Typography>
            </CardContent>
          </Card> */}
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          {/* <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="h5" fontWeight="bold">
                Operaciones Terminadas
              </Typography>
              <Typography variant="h6" gutterBottom>
                9
              </Typography>
            </CardContent>
          </Card> */}
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          {/* <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <CardContent>
              <Typography variant="h5" fontWeight="bold">
                Total Operaciones Este Año
              </Typography>
              <Typography variant="h6" gutterBottom>
                16
              </Typography>
            </CardContent>
          </Card> */}
        </Grid>

        {/* {stats.map((stat) => (
          <Grid item xs={12} sm={6} md={4} key={stat.label}>
            <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  {stat.label}
                </Typography>
                <Typography variant="h4" fontWeight="bold">
                  {stat.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))} */}
      </Grid>
    </Box>
  );
};

export default Dashboard;
